// extracted by mini-css-extract-plugin
module.exports = {"ProductCard":"product-card_ProductCard__n_hzv","Gallery":"product-card_Gallery__pHO4q","Props":"product-card_Props__YRTc3","Description":"product-card_Description__hCISw"};